import React, { useRef, useState } from "react";
import "./video.css";
import vdo1 from "../assets/gallery/videos/1.mp4";
import vdo2 from "../assets/gallery/videos/2.mp4";
import vdo3 from "../assets/gallery/videos/3.mp4";
import vdo4 from "../assets/gallery/videos/4.mp4";
import vdo5 from "../assets/gallery/videos/5.mp4";
import vdo6 from "../assets/gallery/videos/6.mp4";
import vdo7 from "../assets/gallery/videos/7.mp4";
import vdo8 from "../assets/gallery/videos/8.mp4";
import vdo9 from "../assets/gallery/videos/9.mp4";
import vdo10 from "../assets/gallery/videos/10.mp4";
import vdo11 from "../assets/gallery/videos/11.mp4";
import vdo12 from "../assets/gallery/videos/12.mp4";
import vdo13 from "../assets/gallery/videos/13.mp4";
import vdo14 from "../assets/gallery/videos/14.mp4";
import vdo15 from "../assets/gallery/videos/15.mp4";
import vdo16 from "../assets/gallery/videos/16.mp4";
// import vdo17 from "../assets/gallery/videos/17.mp4";
const videos = [
  { id: 1, src: vdo1, title: "Court Speech" },
  { id: 2, src: vdo2, title: "Campaign Video" },
  { id: 3, src: vdo3, title: "Public Speech" },
  { id: 4, src: vdo4, title: "Public Speech" },
  { id: 4, src: vdo4, title: "Public Speech" },
  { id: 5, src: vdo5, title: "Public Speech" },
  { id: 6, src: vdo6, title: "Public Speech" },
  { id: 7, src: vdo7, title: "Public Speech" },
  { id: 8, src: vdo8, title: "Public Speech" },
  { id: 9, src: vdo9, title: "Public Speech" },
  { id: 10, src: vdo10, title: "Public Speech" },
  { id: 11, src: vdo11, title: "Public Speech" },
  { id: 12, src: vdo12, title: "Public Speech" },
  { id: 13, src: vdo13, title: "Public Speech" },
  { id: 14, src: vdo14, title: "Public Speech" },
  { id: 15, src: vdo15, title: "Public Speech" },
  { id: 16, src: vdo16, title: "Public Speech" },
];

export default function VideoGallery() {
  const [currentVideo, setCurrentVideo] = useState("");
  const videoRef = useRef(null);

  const openVideo = (src) => {
    setCurrentVideo(src);
    setTimeout(() => {
      videoRef.current?.play();
    }, 300);
  };

  const closeVideo = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
    setCurrentVideo("");
  };

  return (
    <div className="container py-5">
      <h2 className="text-center mb-5">🎥 Video Gallery</h2>

      <div className="row g-4">
        {videos.map((video) => (
          <div className="col-md-4 col-sm-6" key={video.id}>
            <div className="video-card" onClick={() => openVideo(video.src)}>
              <video
                src={video.src}
                muted
                preload="metadata"
                onMouseOver={(e) => e.target.play()}
                onMouseOut={(e) => {
                  e.target.pause();
                  e.target.currentTime = 0;
                }}
                className="video-thumb"
              />
              <div className="play-btn">▶</div>
              {/* <div className="video-title">{video.title}</div> */}
            </div>
          </div>
        ))}
      </div>

      {/* MODAL */}
      {currentVideo && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content bg-dark">
              <div className="modal-header border-0">
                <button
                  className="btn-close btn-close-white"
                  onClick={closeVideo}
                ></button>
              </div>

              <div
                className="modal-body p-0"
                style={{
                  width: "100%",
                  height: "70vh",
                  background: "black",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <video
                  ref={videoRef}
                  src={currentVideo}
                  controls
                  autoPlay
                  playsInline
                  style={{
                    width: "100%",
                    maxHeight: "80vh",
                    objectFit: "contain",
                    background: "black",
                    zIndex: 9999,
                  }}
                />
              </div>
            </div>
          </div>

          {/* backdrop */}
          <div className="modal-backdrop fade show" onClick={closeVideo}></div>
        </div>
      )}
    </div>
  );
}
